import { emptyTitle, getWordContentFn } from '@/util/serviceContract'

const directSalesContractWord = [
  {
    title: ``,
    word: [
      `尊敬的<span class="themeColor underline">${emptyTitle}#contactName#${emptyTitle}</span>先生/女士，`,
      `您从梅赛德斯-奔驰授权经销商/服务中心处为底盘号为
      <span class="themeColor underline">${emptyTitle}#fin#${emptyTitle}</span>
      的梅赛德斯-奔驰品牌乘用车购买
      <span class="themeColor underline">${emptyTitle}#productName#${emptyTitle}</span>，
      即进一步享有自合同生效之日起
      <span class="themeColor underline">${emptyTitle}#effectiveMonth#${emptyTitle}</span>
      个月或限定次数的保养服务完成之日（以先到者为准，“合同有效期”）的原厂保养服务，服务限定次数如下。`
    ]
  }
]

const ewContractWord = option => {
  console.log('ewContractWord option', option)
  const productType = option.productType
  return [
    {
      title: ``,
      word: [
        `尊敬的<span class="themeColor underline">${emptyTitle}#contactName#${emptyTitle}</span>先生/女士，`,
        `您从梅赛德斯-奔驰授权经销商/服务中心处为底盘号
        <span class="themeColor underline">${emptyTitle}#fin#${emptyTitle}</span>
        的梅赛德斯-奔驰品牌乘用车，购买了原厂延长保修服务。<br><br>
        产品最长有效期：${option.validPeriod === -1 ? '- ' : `<span class="themeColor underline">${emptyTitle}#validPeriod#${emptyTitle}</span>`}个月 
        <br>
        产品结束时的车辆总行驶里程：<span class="themeColor underline">${emptyTitle}#maxPurchaseMile#${emptyTitle}</span>公里<br>
        产品有效期计算基准日期：<span class="themeColor underline">${emptyTitle}#startDate#${emptyTitle}</span>
        ${productType !== 'PRD_CATEGORY_17' ? `（如因特殊原因涉及变更，请咨询经销商确认）` : ''}
        <br>
        产品结束日期：${option.endDate === -1 ? '-' : `<span class="themeColor underline">${emptyTitle}#endDate#${emptyTitle}</span>`}
        ${productType !== 'PRD_CATEGORY_17' ? `（如车辆行驶里程先于产品结束日期达到产品结束时车辆总行驶里程，以该时间为产品结束日期）` : ''}
        <br>
        产品起始时的车辆行驶里程：- ${
          productType !== 'PRD_CATEGORY_17' ? `（以产品有效期计算基准日期车辆的实际行驶里程为准）` : '（以创建订单时车辆实际行驶里程为准）'
        }`
      ]
    }
  ]
}

const ewUsedCarContractWord = option => [
  {
    title: ``,
    word: [
      `尊敬的<span class="themeColor underline">${emptyTitle}#contactName#${emptyTitle}</span>先生/女士，`,
      `您的底盘号<span class="themeColor underline">${emptyTitle}#fin#${emptyTitle}</span>的梅赛德斯-奔驰品牌乘用车，享有官方认证二手车原厂整车保修服务。<br><br>
      产品有效期：${option.validPeriod === -1 ? '- ' : `<span class="themeColor underline">${emptyTitle}#validPeriod#${emptyTitle}</span>`}个月<br>
      产品结束时的车辆总行驶里程：${
        option.maxPurchaseMile === '不限制' ? '不限制' : `<span class="themeColor underline">${emptyTitle}#maxPurchaseMile#${emptyTitle}</span>公里`
      }<br>
      产品有效期计算基准日期：<span class="themeColor underline">${emptyTitle}#startDate#${emptyTitle}</span>（如因特殊原因涉及变更，请咨询经销商确认）<br>
      产品结束日期：${option.endDate === -1 ? '-' : `<span class="themeColor underline">${emptyTitle}#endDate#${emptyTitle}</span>`}<br>
      产品起始时的车辆行驶里程：${
        option.exceedMileStart === '-' ? '-' : `<span class="themeColor underline">${emptyTitle}#exceedMileStart#${emptyTitle}</span>公里`
      }（以产品有效期计算基准日期车辆实际行驶里程为准）`
    ]
  }
]

const vulnerablePartContractWord = [
  {
    title: ``,
    word: [
      `尊敬的<span class="themeColor underline">${emptyTitle}#contactName#${emptyTitle}</span>先生/女士，`,
      `您于<span class="themeColor underline">${emptyTitle}#year#${emptyTitle}</span>年
      <span class="themeColor underline">${emptyTitle}#month#${emptyTitle}</span> 月
      <span class="themeColor underline">${emptyTitle}#day#${emptyTitle}</span> 日
      从梅赛德斯-奔驰授权经销商处购买的底盘号为
      <span class="themeColor underline">${emptyTitle}#fin#${emptyTitle}</span>
      的梅赛德斯-奔驰品牌乘用车，购买了原厂易损件套餐，即进一步享有自合同生效之日起六年，含限定次数的保养服务(以先到者为准，服务限定次数如下) 。
      为了更好的享受梅赛德斯-奔驰原厂易损件套餐，请您关注以下服务细则：`
    ]
  }
]

const directUserContractWord = [
  {
    title: ``,
    word: [
      `欢迎您使用梅赛德斯-奔驰客户服务官方微信【原厂保养服务套餐或原厂延长保修服务线上订购】功能（以下简称“本功能“）！为了使用本功能，请先仔细阅读、理解并接受Mercedes me ID （梅赛德斯-奔驰账户）及梅赛德斯-奔驰平台服务协议以及平台服务隐私政策。在您确认阅读并同意该平台服务协议及隐私政策的情况下，您一旦使用本功能服务，即视为您已阅读并同意本功能用户服务协议。本用户服务协议（“本协议”）由用户（“用户”）与梅赛德斯-奔驰（中国）汽车销售有限公司（以下简称“梅赛德斯-奔驰公司或奔驰”）订立，并适用于服务中提供的所有基于互联网和移动互联网的相关服务（以下简称“网络服务”）。`
    ]
  },
  {
    title: `第一条${emptyTitle}商品订购`,
    word: [
      '本功能中的商品为【原厂保养服务套餐或原厂延长保修服务】，其所涉服务由用户选定的经销商向用户提供，用户订购并支付订单即视为与该经销商达成服务合同。具体服务条款请见《客户告知书》。'
    ]
  },
  {
    title: `第二条${emptyTitle}商品激活`,
    word: [
      '您所购买的商品将于您支付订单款项7天（即自支付成功开始计算，7*24小时）后自动激活。您也可在商品自动激活前选择任意时间激活使用。商品激活通常意味着服务合同生效，具体服务合同生效时间及服务合同期限请以《客户告知书》为准。'
    ]
  },
  {
    title: `第三条${emptyTitle}商品退订`,
    word: [
      '您有权退订您尚在合同有效期内且未使用的原厂保养服务套餐商品或未进入使用期的原厂延长保修服务商品。',
      '若您所购买的商品订单未激活，可以申请线上退款，若订单退款成功，则根据订单实付款金额退还原支付账户。',
      '若您所购买的商品订单已激活，请恕无法申请线上退款，然您可联系购买时所选经销商办理线下退货手续，经销商联系方式可在订单中查询。',
      '组合商品退款规则：',
      '由于组合订单享有叠加优惠，组合内的商品订单无法进行单独退款申请。',
      '如组合订单内的所有商品订单均未激活，可以申请线上整单全额退款，若订单全额退款成功，则根据订单实付款金额退还原支付账户。',
      '如组合订单内的订单已激活，则无法申请线上退款，如需退款需联系购买时所选经销商办理线下退货手续，经销商联系方式可在订单中查询。'
    ]
  }
]

const getDirectSalesContractContentFn = option => getWordContentFn(directSalesContractWord, option)
const getContractContentCommonFn = option => {
  if (option.isWpProduct === 'wp') {
    option.sign = 'wpProduct'
  }
  if (option.isWpProduct === 'nev') {
    option.sign = 'nevProduct'
  }
  let res = ''
  let sign = option?.sign
  switch (sign) {
    case 'contractUser':
      res = getWordContentFn(directUserContractWord, option)
      break
    case 'wpProduct':
      res = getWordContentFn(vulnerablePartContractWord, option)
      break
    case 'ewProduct':
      res = getWordContentFn(ewContractWord(option), option)
      break
    case 'ewUsedCarProduct':
      res = getWordContentFn(ewUsedCarContractWord(option), option)
      break
    default:
      res = getWordContentFn(directSalesContractWord, option)
      break
  }
  return res
}

export { getDirectSalesContractContentFn, getContractContentCommonFn }
